import Cookies from 'js-cookie';

export default class Persist {

    persist(key, value) {
        const jsonData = JSON.stringify({value: value});
        localStorage.setItem(key, jsonData);
        Cookies.set(key, jsonData, {expires: 365});
    }

    load(key, defaultValue) {
        let localStorageData = null;
        try {
            localStorageData = JSON.parse(localStorage.getItem(key)) || null;
        } catch (e) {
        }

        if (localStorageData !== null && 'value' in localStorageData) {
            return localStorageData.value;
        }

        let cookieData = null;
        try {
            cookieData = JSON.parse(Cookies.get(key)) || null;
        } catch (e) {
        }

        if (cookieData !== null && 'value' in cookieData) {
            this.persist(key, cookieData.value);
            return cookieData.value;
        }

        return defaultValue;
    }
}
